import * as React from 'react';
import { useQuery } from 'react-query';
import { getLeadSources } from '~/api/routes/leadad/options';
import Selector, { SelectorProps } from './Selector';

// TODO For some reason Omit doesnt work here. This will need to be resolved at some point
function SourceSelector(props: SelectorProps & { options?: string[] }) {
  const query = useQuery(['leadad', 'sources'], getLeadSources, {
    initialData: ['RG FB Tool Lead Ad'],
  });

  return (
    <Selector
      isLoading={query.isLoading}
      options={query.data}
      {...props}
    />
  );
}

export default React.memo(SourceSelector);
